import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { HttpRequestService } from 'src/app/http-request.service';
import { Injectable } from '@angular/core';
import { AnyRecord } from 'dns'; 
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/loader.service';

@Component({
  selector: 'app-kyc-modal',
  templateUrl: './kyc-modal.component.html',
  styleUrls: ['./kyc-modal.component.scss']
})
export class KycModalComponent implements OnInit {

  @Input() kycData:any='';
  @Output() sendStatus:EventEmitter<any> = new EventEmitter();
  id: number;
  C_Id: any;
  mandate_decision: any;
  Mobile: any;
  kyc_decision_status: any;
  flat: string;
  postoffice: string;
  District: string;
  Pincode: string;
  State: string;
  application_id: string;
  afterVerifedOTP: boolean;
  ngOtpInput: any;
  wrongOTP: any;
  showOtpSection: boolean;
  msgStepper_112: boolean;
  msgStepper_113: boolean;
  datePipe: DatePipe = new DatePipe('en-US');
   transformDate: string;
   showLoader:boolean;

  constructor(private activeModal: NgbActiveModal,
    private service: HttpRequestService,
    private loader: LoaderService) { }
    Contact_Id
  ngOnInit(): void {
   
    this.Contact_Id = sessionStorage.getItem('Contact_id');
  sessionStorage.getItem('Contact_id')
  this.application_id=sessionStorage.getItem('Application_id')

}

  get currentModal(){
    return this.activeModal;
  }

kyc_decision : any; 
checkcallbackstatus(){
  const body={
    Mobile:sessionStorage.getItem('Mobile')
  }
  this.service.callback(body).subscribe(res=>{          
             
    this.kyc_decision_status= res.Data.KYC_Status; 

   
   
    if(this.kyc_decision_status=='Approved') 
    {
      
    
     this.sendStatus.emit({status:'Success',value:1,response:res});
    } 
   else{
    this.sendStatus.emit({status:'KycFail',value:1,response:''});}


});
}  
msgStepper_1005:boolean;msgStepper_1006:boolean;
@Output() lds = new EventEmitter();
otpOption:boolean=false;
hideaccept :boolean=false;
hidereject :boolean=false;
config = {
  allowNumbersOnly: true,
  length: 5,
  isPasswordInput: false,
  disableAutoFocus: false,
  placeholder: '',
  inputStyles: {
  'border-bottom': '1px solid #b7b5b5',
  'outline': 'none',
  'border-top': 'none',
  'border-left': 'none',
  'border-right': 'none',
  'margin-bottom': '10px',
  'height': '24px'
  }
};  



  
 

ldsaccepted()
{  
  this.otpOption=true;
  this.hideaccept=!this.hideaccept;
  this.hidereject=!this.hidereject;  
  this.showLoader=true;
  this.Mobile=sessionStorage.getItem('Mobile');
  this.application_id = sessionStorage.getItem('Application_id')
  var today = new Date;
  var hour = today.getHours();
  var min = today.getMinutes();
  var sec = today.getSeconds();
  var currenttime = hour + ":" + min + ":" + sec;
  var transformDate = this.datePipe.transform(today, 'yyyy-MM-dd');
  var timestamp = transformDate + '' +currenttime;


  const body1={
    Request_Key:'',
    Mobile:this.Mobile,
    Event_Name:'Proceed For LDS Accept',
    Event_Type:'Button',
    Origin:'Frontend',
    Partner_Name:'DMI Finance',
    Remark_1: '',
    Remark_2:'',
    Remark_3:'',
    Remark_4:'',
    Remark_5:''
  
  }
  this.service.getEventTrack(body1).subscribe(res => {

  });

const body={
  Mobile:this.Mobile,LDS_OTP_Signature:'',LDS_OTP_Request_Time_Stamp:timestamp,LDS_OTP_Verify_Time_Stamp:''
}
 
  
     this.service.ldsAccepted(body).subscribe(res=>{
        if(res.Status == 200)
        { 
        // this.showLoader=false;
        const body={
          Application_Id:this.application_id
         }
       
  this.service.afterlds(body).subscribe(res=>{  
    if(res.Status==200) 
    {
    this.sendStatus.emit({status:'Success',value:1,response:''}); 
    this.showLoader=false;
    this.currentModal.dismiss();
    }
    
   
    // setTimeout(() => {this.checkcallbackstatus()}, 5000);

  });
}
});
}

ldsrejectedted()

{   


  const body1={
    Request_Key:'',
    Mobile:this.Mobile,
    Event_Name:'LDS Reject',
    Event_Type:'Button',
    Origin:'Frontend',
    Partner_Name:'DMI Finance',
    Remark_1: '',
    Remark_2:'',
    Remark_3:'',
    Remark_4:'',
    Remark_5:''
  
  }
  this.service.getEventTrack(body1).subscribe(res => {

  });
  this.sendStatus.emit({status:'Fail',value:1,response:''}); 
  this.currentModal.dismiss();
}







  showStatus(){
    this.currentModal.dismiss();
    if(this.kycData.id == 1){ 
     

      let Contact_Id = sessionStorage.getItem('Contact_id');
     
      const body={
        Contact_Id: sessionStorage.getItem('Contact_id')
      }
      
     
          this.service.kyc_callback(body).subscribe(res=>{

           this.kyc_decision=res['Data'] 
           
           
            
            sessionStorage.setItem('Street',this.kyc_decision[0].Street)
            sessionStorage.setItem('Post_Office',this.kyc_decision[0].Post_Office)
            sessionStorage.setItem('District',this.kyc_decision[0].District)
            sessionStorage.setItem('Pincode',this.kyc_decision[0].Pincode) 
            sessionStorage.setItem('State',this.kyc_decision[0].State)  
      
          });
          setTimeout(() => {this.checkcallbackstatus()}, 1000); 

  
    } 

    else if(this.kycData.id == 3){

     let Mobile = sessionStorage.getItem('Mobile');
     const inter = setInterval(() =>  {
       
      const body={
        Mobile:Mobile
      }
     this.service.callback(body).subscribe(res=>{
       
      this.mandate_decision=res['Data'] 
    

     

      if(this.mandate_decision.NACH_Status !='') 
      {
       
         if(this.mandate_decision.Opportunity_Id !='')
         {

          clearInterval(inter);
         }
      
       this.sendStatus.emit({status:'Success',value:1,response:res});
      } 
     else{
      this.sendStatus.emit({status:'Emandate Failed',value:1,response:''});}

     });
    }, 2000);
      
    }
    
    
    }

  cancelback(){
    this.kycData.id=false;
  }
}


